import { useEffect, useMemo } from 'react';
import './App.scss';
import CreateCharacter from './components/CreateCharacter/CreateCharacter';
import FightScene from './components/FIghtScene/FightScene';
import MainScene from './components/MainScene/MainScene';
import { useAppSelector } from './store/store';
import Locations from './components/locations/Locations';
import ExplorationScene from './components/locations/ExplorationScene/ExplorationScene';
import Shop from './components/shop/Shop';
import { soundToPlay } from './mechanics/sounds/sound';
import ChestScene from './components/locations/ChestScene/ChestScene';
import DialogScene from './components/locations/DialogScene/DialogScene';
import Camp from './components/Camp/Camp';
import CampAllies from './components/Camp/CampAllies/CampAllies';
import CampCharacterUpgrade from './components/Camp/CampCharacterUpgrade/CampCharacterUpgrade';
import CampEquipmentUpgrade from './components/Camp/CampEquipmentUpgrade/CampEquipmentUpgrade';
import LoaderController from './controllers/LoaderController';
import Loader from './components/ui/Loader';

function App() {
  const scene = useAppSelector(state => state.SceneReducer.scene)

  useEffect(() => {
    soundToPlay("mainMusic")
  }, [])

  const getScene = useMemo(() => {
    switch (scene) {
      case "create":
        return <CreateCharacter />
      case "main":
        return <MainScene />
      case "fight":
        return <FightScene />
      case "Locations":
        return <Locations />
      case "shop":
        return <Shop />
      case "explore":
        return <ExplorationScene />
      case "chest":
        return <ChestScene />
      case "dialog":
        return <DialogScene />
      case "camp":
        return <Camp />
      case "campAllies":
        return <CampAllies />
      case "campCharacterUpgrade":
        return <CampCharacterUpgrade />
      case "campEquipmentUpgrade":
        return <CampEquipmentUpgrade />
      default:
        return <MainScene />
    }
  }, [scene])

  return (
    <div className="App">
      <LoaderController loader={<Loader />}>
        {getScene}
      </LoaderController>
    </div>
  )
}

export default App;
